import { NgModule } from '@angular/core';
import { MetricComponent } from '@client/shared/components/metric/metric.component';
import { ProgressBarModule } from '@shared/component/progress-bar/progress-bar.module';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    MetricComponent
  ],
  imports: [
    ProgressBarModule,
    CommonModule
  ],
  exports: [
    MetricComponent
  ]
})
export class MetricModule { }
